const routes = {
  getUserProfile: 'user/profile',
  getUsers: 'user/',
  createUser: 'user/'
};

export default routes